/**
 * Location Edit - Websites Field
 *
 * TODO(mattjs) Suggested edits
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.Websites');
goog.provide('yext.location.Website');

goog.require('yext');
goog.require('yext.textfield');
goog.require('yext.location.helpers');

/**
 * @param {!jQuery} $ctx Context for the website field
 * @constructor
 */
yext.location.Websites = function($ctx) {
  this.$ctx = $ctx;
  this.$fieldValue = $ctx.find('.js-field-json-value');

  this.displayRowTemplate = $ctx.find('.js-website-display-row').html();
  this.websites = {};
  this.timestamp = $ctx.data('timestamp');

  this.constructWebsites();
  this.storeValue();
  this.setFieldJSONValue();
  this.bindings();
};

/**
 * Builds Website objects from DOM elements
 */
yext.location.Websites.prototype.constructWebsites = function() {
  var self = this;
  this.$ctx.find('.js-website-container').each(function() {
    var website = new yext.location.Website($(this));
    self.websites[website.urlType] = website;
    $(website).on('updated', function() {
      self.message('updated');
    });
  });
};

/**
 * Stores the value of the module to be restored
 */
yext.location.Websites.prototype.storeValue = function() {
  for (var urlType in this.websites) {
    this.websites[urlType].storeValue();
  }
};

/**
 * Bind the show other websites link & update field value
 */
yext.location.Websites.prototype.bindings = function() {
  var self = this;
  this.$ctx.find('.js-add-other-websites').click(function() {
    self.toggleOtherSection(true);
  });
  $(this).on('updated', function() {
    self.setFieldJSONValue();
  });
};

/**
 * Syncs the hidden input with the current JSON value of the field
 */
yext.location.Websites.prototype.setFieldJSONValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.get()));
};

/**
 * Toggles the other websites link and section
 *
 * @param {boolean} show True to show the other websites
 */
yext.location.Websites.prototype.toggleOtherSection = function(show) {
  this.$ctx.find('.js-add-other-websites-container').toggle(!show);
  this.$ctx.find('.js-other-websites').toggle(show);
};

/**
 * @param {string} message The message to be broadcast with the Websites instance as context
 */
yext.location.Websites.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Reset the module to a stored state
 */
yext.location.Websites.prototype.reset = function() {
  for (var urlType in this.websites) {
    this.websites[urlType].reset();
  }
  this.render();
};

/**
 * Update the state of the module
 *
 * @param {!Object} field JSON Serialized WebsiteView.java
 */
yext.location.Websites.prototype.set = function(field) {
  this.timestamp = field['timestamp'];
  for (var i = 0; i < field['websites'].length; i++) {
    var website = field['websites'][i];
    this.websites[website.urlType].set(website);
  }
  this.render();
};

/**
 * Get the state of the field
 *
 * @return {!Object} Field details
 */
yext.location.Websites.prototype.get = function() {
  var websites = [];
  for (var urlType in this.websites) {
    websites.push(this.websites[urlType].get());
  }
  return {
    'websites': websites,
    'timestamp': this.timestamp,
  };
};

/**
 * All UI updates outside of text fields will be done in this method
 */
yext.location.Websites.prototype.render = function() {
  this.toggleOtherSection(this.otherWebsitesHaveValues());
};

/**
 * @return {boolean} True if websites other than EXTERNAL have a value
 */
yext.location.Websites.prototype.otherWebsitesHaveValues = function() {
  for (var urlType in this.websites) {
    if (urlType !== 'EXTERNAL' && this.websites[urlType].hasValue()) {
      return true;
    }
  }
  return false;
};

/**
 * Builds the HTML for the display mode
 *
 * @return {JQuery|string} Rendered display mode of the field's current value
 */
yext.location.Websites.prototype.getDisplayValue = function() {
  var external = '';
  var other = [];
  var empty = true;

  for (var urlType in this.websites) {
    var website = this.websites[urlType];
    if (website.hasValue()) {
      if (website.urlType === 'EXTERNAL'
          // NOTE (yliu): This is for entity page
          || website.urlType === 'location.website') {
        external = this.renderWebsiteRow(website);
      } else {
        other.push(this.renderWebsiteRow(website));
      }
      empty = false;
    }
  }

  if (empty) {
    return yext.location.helpers.emptyFieldMessage();
  } else {
    return $('<table class="websites-display-table" />').append(external + other.join(''));
  }
};

/**
 * Renders an HTML table row for the provided website
 *
 * @param {yext.location.Website} Single website instance
 * @return {string} Table row representing the state of the website
 */
yext.location.Websites.prototype.renderWebsiteRow = function(website) {
  var result = this.displayRowTemplate.replace('&#123;&#123;urlLabel&#125;&#125;', website.label);
  result = result.replace('&#123;&#123;urlContent&#125;&#125;', website.url.viewMarkupAsString());
  result = result.replace('&#123;&#123;displayUrlContent&#125;&#125;', website.displayUrl.viewMarkupAsString());
  return result;
};

/**
 * TODO(mattjs) preferDisplayUrlIndeterminate
 *
 * @constructor
 */
yext.location.Website = function($ctx) {
  this.$ctx = $ctx;
  this.$radios = $ctx.find('.js-delivery-options input[type=radio]');

  this.urlType = $ctx.data('urlType');
  this.label = $ctx.data('label');
  // Unset (undefined) will be used to indicate indeterminate
  this.preferDisplayUrl = this.$radios.filter(':checked').val();

  this.constructTextFields();
  this.storeValue();
  this.bindings();
};

/**
 * Checks if the url and the display url are the same
 *
 * @return {boolean} True if they are equal
 */
yext.location.Website.prototype.areSame = function() {
  return this.url.value() === this.displayUrl.value()
    && !this.fieldHasInheritedAsset()
    && !(this.url.model.indeterminate || this.displayUrl.model.indeterminate);
};

/**
 * @return {boolean} True of url or display url are inherited assets
 */
yext.location.Website.prototype.fieldHasInheritedAsset = function() {
  return this.url.isInheritedAsset || this.displayUrl.isInheritedAsset;
};

/**
 * Store the current value of the website field
 */
yext.location.Website.prototype.storeValue = function() {
  this.previousPreferDisplayUrl = this.preferDisplayUrl;
  this.url.saveValue();
  this.displayUrl.saveValue();
};

/**
 * Construct TextField objects and set inSync value
 */
yext.location.Website.prototype.constructTextFields = function() {
  var $url = this.$ctx.find('.js-url-container .js-text-field');
  var $displayUrl = this.$ctx.find('.js-display-url-container .js-text-field');
  var idForTextField = this.getIdForTextField();

  this.url = yext.textfield.createWithUsageType($url, idForTextField);
  this.displayUrl = yext.textfield.createWithUsageType($displayUrl, idForTextField);
  this.inSync = this.areSame();
};

/**
 * @return {string} Returns the field id to pass in to the text field
 */
yext.location.Website.prototype.getIdForTextField = function() {
  // NOTE(schakraborty): This if case is for location edit
  if (this.urlType == 'EXTERNAL'
      || this.urlType == 'MENU'
      || this.urlType == 'ORDER'
      || this.urlType == 'RESERVATION') {
    return this.getParentFieldId();
  }
  // NOTE(schakraborty): This case is for entity edit
  return this.urlType;
};

/**
 * @return {string} Returns the field id of the parent wrapper.
 */
yext.location.Website.prototype.getParentFieldId = function() {
  if (this.$ctx.closest('.js-websites-field').length) {
    return this.$ctx.closest('.js-websites-field').find('input[name=field]').val();
  }
  return null;
};

/**
 * All DOM bindings go here
 */
yext.location.Website.prototype.bindings = function() {
  var self = this;
  this.$radios.on('change, click', function() {
    var preferDisplayUrl = self.$radios.filter(':checked').val();
    if (preferDisplayUrl != self.preferDisplayUrl) {
      self.preferDisplayUrl = preferDisplayUrl;
      self.message('updated');
    }
  });

  $(this.url).on('update.textField', function() {
    if (self.inSync) {
      self.displayUrl.set(self.url.model);
    }
    self.inSync = self.areSame();
    self.message('updated');
  });

  $(this.displayUrl).on('update.textField', function() {
    self.inSync = self.areSame();
    self.message('updated');
  });
};

/**
 * @return {boolean} True if the field has a value (or is indeterminate)
 */
yext.location.Website.prototype.hasValue = function() {
  return (!!this.url.model.displayValue || this.url.model.displayIndeterminate)
    || (!!this.displayUrl.model.displayValue || this.displayUrl.model.displayIndeterminate);
};

/**
 * Reset the field to a previously stored state
 */
yext.location.Website.prototype.reset = function() {
  this.url.reset();
  this.displayUrl.reset();
  this.preferDisplayUrl = this.previousPreferDisplayUrl;
  this.render();
};

/**
 * All DOM updates to a website outside of TextField go here
 */
yext.location.Website.prototype.render = function() {
  if (this.preferDisplayUrl == undefined) {
    this.$radios.prop('checked', false);
  } else {
    this.$ctx.find('input[type=radio][value=' + this.preferDisplayUrl + ']')
      .prop('checked', true);
  }
};

/**
 * Updates the state of the Website. Used to sync with backend after a save
 *
 * @param {!Object} website Plain object version of this module
 */
yext.location.Website.prototype.set = function(website) {
  this.url.set(website['url']);
  this.displayUrl.set(website['displayUrl']);
  // When preferDisplayUrlIndeterminate is true, preferDisplayUrl is unset (undefined)
  this.preferDisplayUrl =
    website['preferDisplayUrlIndeterminate'] ? undefined : website['preferDisplayUrl'];
  this.render();
};

/**
 * Broadcast a message with the instance as context
 *
 * @param {string} message The message type
 */
yext.location.Website.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * @return {!Object} The current state of website
 */
yext.location.Website.prototype.get = function() {
  return {
    url: this.url.coreData(),
    displayUrl: this.displayUrl.coreData(),
    preferDisplayUrl: this.preferDisplayUrl,
    preferDisplayUrlIndeterminate: this.preferDisplayUrl == undefined ? true : undefined,
    urlType: this.urlType,
  };
};
